import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28, as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.001, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 0.84, 0.24, 1] }}
    >
      {children}
    </M>
  );
};
